export default __webpack_public_path__ + "static/media/sig-core.94be098b.svg";